import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="mb-4">
              <img src="/images/golflogo.jpg" alt="Golf Marshal Logo" className="h-12" />
            </div>
            <p className="text-gray-300 mb-4">
              Comprehensive event management software for golf pros and superintendents.
            </p>
            <div className="text-gray-300 space-y-1.5 mb-4 text-sm">
              <p>
                Call or Text:{' '}
                <a href="tel:+13055827571" className="hover:text-white underline-offset-2 hover:underline">
                  +1.305.582.7571
                </a>
              </p>
              <p>
                <a href="mailto:hello@getgolfmarshal.com" className="hover:text-white underline-offset-2 hover:underline">
                  hello@getgolfmarshal.com
                </a>
              </p>
            </div>
            <div className="flex space-x-4">
              {/* NGCOA */}
              <a href="https://www.ngcoa.org/home" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white flex items-center" aria-label="NGCOA">
                <img src="/images/ngcoa.png" alt="NGCOA" className="h-12 w-auto" />
              </a>
              {/* Facebook */}
              <a href="https://www.facebook.com/GolfMarshalSoftware/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white" aria-label="Facebook">
                <svg className="h-12 w-12" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
              {/* LinkedIn */}
              <a href="https://www.linkedin.com/company/74415625/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white" aria-label="LinkedIn">
                <svg className="h-12 w-12" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14C2.24 0 0 2.24 0 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5zM8 20H5V9h3v11zM6.5 7.732c-.966 0-1.75-.79-1.75-1.764S5.534 4.204 6.5 4.204s1.75.79 1.75 1.764-.784 1.764-1.75 1.764zM20 20h-3v-5.604c0-1.337-.025-3.058-1.863-3.058-1.864 0-2.151 1.454-2.151 2.958V20h-3V9h2.881v1.507h.043c.401-.761 1.379-1.563 2.839-1.563 3.037 0 3.6 2.001 3.6 4.605V20z" />
                </svg>
              </a>
              {/* BHI Software */}
              <a href="https://www.bhisoftware.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white flex items-center" aria-label="BHI Software">
                <img src="/images/bhi.png" alt="BHI Software" className="h-12 w-auto" />
              </a>
            </div>
          </div>
          
          <div className="md:text-right">
            <ul className="space-y-2">
              <li><span className="text-gray-400 cursor-default">Blog (Coming Soon)</span></li>
              <li><Link to="/privacy" className="text-gray-300 hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-white">Terms of Service</Link></li>
              <li><Link to="/cookie-policy" className="text-gray-300 hover:text-white">Cookie Policy</Link></li>
              <li><Link to="/tee-sheet-demo" className="text-gray-300 hover:text-white">Tee Sheet Demo</Link></li>
            </ul>
          </div>
        </div>
        
        <hr className="border-gray-800 my-8" />
        
        <div className="flex justify-center items-center">
          <p className="text-gray-300 text-sm text-center">
            &copy; {year} Golf Marshal. All rights reserved.
          </p>
        </div>

        <div className="mt-6 text-xs text-gray-300 text-center">
                     Golf Marshal offers a 100% opt-in and SPAM-FREE service. Message and data rates may apply to opt-ins. At anytime, text STOP to end or HELP for help. Message Privacy Policy: We do not sell, rent, loan, trade, lease, or otherwise transfer any phone number or personal data received through the program to any third party. Golf Marshal follows strict 10DLC guidelines. For more information about 10DLC, visit <a href="https://whatis10dlc.com" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline">What Is 10DLC</a>.
        </div>
      </div>
    </footer>
  );
};

export default Footer; 